const logoutController = () => (dispatch) => {
  dispatch({ type: "LOGOUT" })
  localStorage.removeItem('token');
}

export {
  logoutController
}
